/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Grid, Typography, Fab, Paper } from '@material-ui/core'
import ReadMorePopup from './ReadMorePopup'
import ReadMoreElement from './ReadMoreElement'

const styles = theme => ({
    elementWrapper: {
        padding: '12px 16px 24px 16px!important',
        //border: '1px solid #e5e5e5',
        background: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
        '&:hover': {
            //background: "#f5f5f5",
            boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'
        },
        margin: '0px 0px 32px 0px',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: 10,
        [theme.breakpoints.down(600)]: {
            padding: '16px 16px 16px 16px!important'
        }
    },
    paper: {
        boxShadow: theme.paper ? theme.paper.boxShadow : null,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up(980)]: {
            marginBottom: theme.spacing(5)
        },
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important'
    },
    container: {
        display: 'flex',
        minHeight: 80
    },
    primaryText: {
        color: theme.palette.primaryColor
    },
    accentText: {
        color: theme.palette.secondaryColor
    },
    elementText: {
        paddingTop: '14px!important'
    },
    product: {
        color: theme.palette.primaryColor
    },
    productDescription: {
        fontWeight: 500
    },
    statusIcon: {
        position: 'absolute',
        right: '-1rem',
        bottom: '-1rem',
        fontSize: '6rem',
        opacity: 0.5
    },
    status0Icon: {
        color: '#f33b1b'
    },
    status5Icon: {
        color: '#f3ca1b'
    },
    status10Icon: {
        color: '#00b0ff'
    },
    imageWrapper: {
        display: 'flex',
        padding: '6px 32px 4px 16px',
        flexDirection: 'column'
    },
    image: {
        maxWidth: '100%',
        maxHeight: 60,
        margin: 'auto',
        [theme.breakpoints.down(600)]: {
            maxHeight: 80
        }
    },
    contentWrapper: {
        margin: 'auto',
        paddingBottom: theme.spacing(1)
    },
    elementTitle: {
        lineHeight: '1.4rem'
    },
    elementContentWrapper: {
        padding: '8px'
    },
    button: {
        background: theme.palette.primaryColor,
        color: '#ffffff',
        width: '100%!important',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important',
        //maxWidth: 150,
        minWidth: '140px!important',
        lineHeight: '15px'
    },
    rightIcon: {
        marginLeft: 16,
        marginTop: -3
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '12px 16px 14px 16px',
        flexDirection: 'column',
        [theme.breakpoints.down(600)]: {
            padding: '12px 8px 14px 8px'
        }
    },
    favButtonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0px 16px 56px 16px',
        flexDirection: 'column',
        [theme.breakpoints.down(600)]: {
            padding: '0px 8px 32px 8px'
        }
    },
    topDivider: {
        borderTop: '1px solid #eaeaea',
        marginTop: 8,
        paddingTop: 4
    },
    requestDivider: {
        marginTop: 8,
        paddingTop: 8
    },
    smallContent: {
        fontSize: '0.8rem!important',
        color: 'rgba(0,0,0,0.61)!important'
    },
    smallElementTitle: {},
    elementBlockWrapper: {
        padding: '12px 16px 0 16px'
    },
    header: {
        margin: '0 -16px 16px -16px',
        padding: '8px 32px',
        background: '#ececec',
        maxWidth: 'calc(100% + 32px)',
        flexBasis: 'calc(100% + 32px)',
        fontWeight: '500!important',
        textAlign: 'center!important',
        '& span': {
            lineHeight: 1,
            fontWeight: 800
        }
    },
    company: {
        float: 'left'
    },
    productType: {
        float: 'right'
    },
    elementContentItemWrapper: {
        paddingLeft: theme.spacing(7),
        padding: theme.spacing(0.5),
        [theme.breakpoints.down(600)]: {
            paddingLeft: theme.spacing(1)
        }
    },
    elementValue: {
        fontSize: '1.25rem!important',
        fontWeight: '800!important'
    },
    [theme.breakpoints.down(600)]: {
        elementBlockWrapper: {
            padding: '16px 12px 0 12px'
        },
        legend: {
            padding: '0px 0 0px 0!important',
            float: 'left',
            width: 'calc(50% + 8px)',
            [theme.breakpoints.down(600)]: {
                padding: '14px 0 0 0!important'
            }
        },
        elementText: {
            paddingTop: '4px!important',
            marginBottom: '0!important'
        },
        statusIcon: {
            fontSize: '4rem'
        },
        imageWrapper: {
            padding: '8px 16px 16px 8px'
        }
    },
    imageContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        paddingBottom: theme.spacing(1),
        [theme.breakpoints.down(600)]: {
            paddingBottom: 0
        }
    },
    imageTitleWrapper: {
        paddingLeft: theme.spacing(1),
        textAlign: 'left!important',
        [theme.breakpoints.down(600)]: {
            display: 'none'
        }
    },
    imageTitleWrapperElementValue: {
        fontSize: '1rem!important'
    },
    nextStepDescriptionWrapper: {
        flexGrow: 1,
        paddingBottom: theme.spacing(3),
        width: '100%',
        [theme.breakpoints.down(600)]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        }
    },
    nextStepDescription: {
        fontSize: '0.85rem!important',
        fontWeight: '600!important',
        lineHeight: 1.3,
        marginTop: 2
        //color: 'rgba(0,0,0,0.61)!important'
    },
    buttonLink: {
        width: '100%'
    },
    showCompanyInfoButton: {
        padding: `0 ${theme.spacing(2)}px`,
        fontSize: '0.85rem',
        color: theme.palette.primaryColor,
        cursor: 'pointer',
        textAlign: 'center',
        width: '100%',
        marginTop: theme.spacing(1.5),
        [theme.breakpoints.down(600)]: {
            marginTop: 0
        }
    },
    paperTitle: {
        fontSize: '1.5rem!important'
    },
    paperDescription: {
        color: 'rgba(0, 0, 0, 0.54)!important',
        textAlign: 'center!important',
        marginBottom: theme.spacing(3)
    },
    elementTitleContentWrapper: {
        [theme.breakpoints.down(600)]: {
            marginBottom: theme.spacing(1)
        }
    },
    elementContent: {
        fontWeight: '600!important'
    },
    loadingWrapper: {
        minHeight: 200
    },
    priorityClientElementWrapper: {
        textAlign: 'center'
    },
    clientImage: {
        maxWidth: '100%',
        width: 800
    },
    favButton: {
        width: 'auto',
        borderRadius: '10px!important'
    }
})

class ApplicationRequestElement extends PureComponent {
    constructor(props) {
        super(props)

        const pageWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth

        this.state = {
            showCompanyInfo: pageWidth > 600,
            isLoading: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isLoading: false })
        }, 6000)
        if (this.props.autoRefresh) {
            setTimeout(() => {
                location.reload()
            }, 5000)
        }
    }

    handleShowCompanyInfo = () => {
        this.setState({ showCompanyInfo: true })
    }

    render() {
        const { elements, classes, priorityClient, autoRefresh } = this.props
        const { showCompanyInfo, isLoading } = this.state

        if (!elements || elements.length === 0) {
            return null
        }

        console.log('elements', elements, autoRefresh)

        return (
            <>
                {priorityClient ? (
                    <Box className={classes.priorityClientElementWrapper}>
                        {priorityClient.application_completed_image && (
                            <img src={priorityClient.application_completed_image} alt="" className={classes.clientImage} />
                        )}
                    </Box>
                ) : (
                    <Box>
                        <Paper className={classes.paper + ' ' + classes.elementWrapper + ' application-element'} elevation={1}>
                            {isLoading ? (
                                <div className={classes.loadingWrapper + ' loading-bubbles-wrapper'}>
                                    <div className="loading">
                                        <div className="loading-unit loading-unit-1" />
                                        <div className="loading-unit loading-unit-2" />
                                        <div className="loading-unit loading-unit-3" />
                                    </div>
                                </div>
                            ) : (
                                elements.map((element, elementKey) => (
                                    <>
                                        <Grid container className={classes.container + ' ' + classes.requestDivider}>
                                            <Grid item xs={6} sm={6} className={classes.imageWrapper}>
                                                {element.image && <img src={element.image} alt="" className={classes.image} />}
                                            </Grid>
                                            <Grid item xs={6} sm={6} className={classes.contentWrapper}>
                                                <Grid container>
                                                    {element.contentElements.topFirst &&
                                                        element.contentElements.topFirst.map((value, index) => {
                                                            return (
                                                                <Grid item xs={12} sm={6} className={classes.elementTitleContentWrapper}>
                                                                    <Typography variant="overline" className={classes.elementTitle}>
                                                                        {value.title}
                                                                    </Typography>
                                                                    <Typography variant="body2" className={classes.elementContent}>
                                                                        {value.content}
                                                                    </Typography>
                                                                </Grid>
                                                            )
                                                        })}
                                                    {false &&
                                                        element.contentElements.topSecond &&
                                                        element.contentElements.topSecond.map((value, index) => {
                                                            return (
                                                                <Grid item xs={6} sm={3}>
                                                                    <Typography variant="overline" className={classes.elementTitle}>
                                                                        {value.title}
                                                                    </Typography>
                                                                    <Typography variant="body2" className={classes.elementContent}>
                                                                        {value.content}
                                                                    </Typography>
                                                                </Grid>
                                                            )
                                                        })}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                ))
                            )}
                        </Paper>
                    </Box>
                )}
            </>
        )
    }
}

export default withStyles(styles)(ApplicationRequestElement)
